import { Button, Col, Modal, Row } from "react-bootstrap";

export default function HelpModal(props) {
    return (
        <Modal className="fullscreen-modal" show={props.show} onHide={props.handleClose} centered>
            <Modal.Header>
                <Modal.Title>Help</Modal.Title>
                <Button className="ms-auto" variant="primary" onClick={props.handleClose}>
                    Close
                </Button>
            </Modal.Header>
            <Modal.Body>
                <Row>
                    <Col xs={6}>
                        <h5>How to use the app</h5>
                        {props.gameData && props.gameData.customHelp && (<div className="box-container flex-column my-4">
                            <h5 className="mt-0">Info about this game</h5>
                            <p>{props.gameData.customHelp}</p>
                        </div>)}
                        <div className="box-container flex-column my-4">
                            <h5 className="mt-0">Basics</h5>
                            <p>Click a card in your hand to play it in its default area. Click a card in play to tap it. Hold your click to drag and drop a card to the desired area.</p>
                            <p>Click a card in the opponent board to ping it.</p>
                            <p>Right click one of your card to open the quick action menu.</p>
                            <p>Click your deck to draw a card.</p>
                            <p>Click a discrad to see the discarded cards for that player. Right click it to see the removed cards and sideboard.</p>
                        </div>
                        <div className="box-container flex-column my-4">
                            <h5 className="mt-0">Advanced</h5>
                            <p>You only need to create one of each token when using the create token menu, you can change the card count to represent how many you have.</p>
                            <p>Hold your click on your deck to drag and drop the top card of your deck.</p>
                            <p>You can group one of your card to an opponent card by clicking it while in group mode (it will give the card to your opponent).</p>
                            <p>If a card you don't own leaves the board it will be sent back to its owner (except for remove and remove hidden sections).</p>
                            <p>To ungroup one of your cards, drag and drop it out of its parent.</p>
                            <p>You can quickly mill your deck by holding the discard key and clicking your deck.</p>
                        </div>
                    </Col>
                    <Col xs={6}>
                        <h5>Shortcuts</h5>
                        <div className="mt-3 d-flex flex-column">
                            <Shortcut keybind="L" description="Create a link between two cards to show an interraction." />
                            <Shortcut keybind="F" description="Play cards without paying their cost." />
                            <Shortcut keybind="P" description="Ping any card (visible for a short time)." />
                            <Shortcut keybind="S" description="Show one of your card by moving it forward (visible until the end of the turn)." />
                            <Shortcut keybind="D" description="Send the card to the discard." />
                            <Shortcut keybind="H" description="Send the card to your hand." />
                            <Shortcut keybind="R" description="Remove the card from the game." />
                            <Shortcut keybind="T" description="Add the card effect to the pile." />
                            <Shortcut keybind="I" description="Invert the card (rotate the card by 180 degrees)." />
                            <Shortcut keybind="Z" description="Reveal a faced down card or hide a faced up card." />
                            <Shortcut keybind="M" description="Rearrange cards inside areas." />
                            <Shortcut keybind="C / Ctrl+C" description="Increase the primary/secondary counter of the card." />
                            <Shortcut keybind="Up / Down" description="Untap/Tap a card from the ressource area." />
                        </div>
                    </Col>
                </Row>

            </Modal.Body>
        </Modal>
    )

    function Shortcut(props) {
        return (
            <div className='box-container align-items-center my-1'>
                <p className='brighter px-3 py-2 text-nowrap'>{props.keybind}</p>
                <p className='my-0'>{props.description}</p>
            </div>
        )
    }
}